import { transport } from 'config/transport';

export function callApiExportNoiTruReportForAllCongDoanMonthly(yearMonth, pdf = false) {
    return transport.get(`/trunguong/report/noitru`, { params: { yearMonth, pdf }, responseType: 'blob' });
}
